<div class="PGSelectPicker">
        <div class="modal-header">
                <h5 class="modal-title">Seleziona {{label}}</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
                <app-pg-select [options]="options" [multi]="multi" [(ngModel)]="selectedValue" [resource]="resource" [resourceSemantic]="resourceSemantic"></app-pg-select>
        </div>
        <div class="modal-footer">
                <button class="btn btn-secondary" (click)="modal.dismiss();">
                        Annulla
                </button>
                <button class="btn btn-primary" (click)="modal.close(selectedValue);">
                        OK
                </button>
        </div>
</div>